import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Samurai",
  "description": "",
  "published": "2007-01-20T00:00:00.000Z",
  "redirect_from": ["/blog/samurai/swizec/315"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`On a certain forum I sometimes visit somebody posted an animation they did, a cartoon to be more precise. It seems to be made using odd shamanistic techniques of professional artists with a tinge of pepper and a dash of magic to create `}<a parentName="p" {...{
        "href": "http://www.threeleggedlegs.com/work/samurai/"
      }}>{`this beautiful short cartoon`}</a>{` that will blow you away.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      